import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeScore(_id:$_id){
        recordId
      }
}
`
